import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { AppRouter } from './AppRouter';
import type { Environment } from './vite-env.d.ts';

// Set favicon based on environment
const setFavicon = () => {
    const environment = import.meta.env.VITE_ENVIRONMENT as Environment;
    const favicon = document.getElementById('favicon') as HTMLLinkElement;

    // Heart SVG with different colors based on environment
    const getFaviconSvg = (color: string) => {
        const svg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.03L12 21.35Z" fill="${color}"/>
        </svg>`;
        return `data:image/svg+xml;base64,${btoa(svg)}`;
    };

    let color: string;
    switch (environment) {
        case 'live':
            color = '#ed6c02'; // Orange (current production color)
            break;
        case 'dev':
            color = '#2196f3'; // Blue
            break;
        case 'local':
            color = '#9c27b0'; // Purple
            break;
        default:
            color = '#9c27b0'; // Purple (default for local/unknown)
    }

    if (favicon) {
        favicon.href = getFaviconSvg(color);
    }
};

setFavicon();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppRouter />
        </ThemeProvider>
    </StrictMode>,
);
